import { useMemo } from 'react';
import PortalIdParser from 'PortalIdParser';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { LANDING_PAGES_AUTOTRANSLATE, LANDING_PAGES_NO_BRANDING, SITE_PAGES_AUTOTRANSLATE, SITE_PAGES_NO_BRANDING } from '../constants/scopes';
const getScopesURI = portalId => `hubs2/v1/scopes/hub/${portalId}/filter`;
const fetchPortalScopes = () => {
  return http.get(getScopesURI(PortalIdParser.get()), {
    query: {
      scopes: [LANDING_PAGES_NO_BRANDING, LANDING_PAGES_AUTOTRANSLATE, SITE_PAGES_NO_BRANDING, SITE_PAGES_AUTOTRANSLATE]
    }
  }).then(({
    scopes
  }) => scopes);
};
const PortalScopesQuery = registerQuery({
  fieldName: 'portalScopes',
  fetcher: fetchPortalScopes
});
const usePortalScopes = () => {
  const {
    data,
    loading,
    error
  } = useQuery(PortalScopesQuery);
  return useMemo(() => {
    return {
      portalScopes: (data === null || data === void 0 ? void 0 : data.portalScopes) || [],
      hasFetchCompleted: !loading && !error && data
    };
  }, [data, error, loading]);
};
export default usePortalScopes;